import Vue from 'vue'
import auth from "@/auth/authService";
import { api } from './utils/requests';
import store from "./store/store"

import { IonicVueRouter } from '@ionic/vue'
Vue.use(IonicVueRouter)

const router = new IonicVueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [

                {
                    path: '/',
                    redirect: '/dashboard',
                    meta: {
                        rule: 'public'
                    }
                },
                {
                    path: '/dashboard',
                    name: 'dashboard-analytics',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/spv/create',
                    name: 'spv-create',
                    component: () => import('./views/Organisation/Edit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/spv/browse',
                    name: 'spv-list',
                    component: () => import('./views/Organisation/List.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/admin/spv/:organisation_id',
                    name: 'spv-edit',
                    component: () => import('./views/Organisation/Edit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                }, 
                // Report
                {
                    path: '/report',
                    name: 'report',
                    component: () => import('./views/Report.vue'),
                    meta: {
                        rule: 'admin',
                    }
                }, 
                // Entry Report
                {
                    path: 'report/entries',
                    name: 'entries-report',
                    component: () => import('./views/Reports/EntryReport.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                 // management
                {
                    path: '/management',
                    name: 'management',
                    component: () => import('./views/Management.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // Dropdown
                // category 
                {
                    path: '/dropdown/categories',
                    name: 'category-list',
                    component: () => import('./views/DropDown/Category/CategoryList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/category/new',
                    name: 'category-new',
                    component: () => import('./views/DropDown/Category/CategoryEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/category/:category_id',
                    name: 'category-edit',
                    component: () => import('./views/DropDown/Category/CategoryEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // issue type 
                {
                    path: '/dropdown/issue-types',
                    name: 'issue-type-list',
                    component: () => import('./views/DropDown/IssueType/IssueTypeList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/issue-type/new',
                    name: 'issue-type-new',
                    component: () => import('./views/DropDown/IssueType/IssueTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/issue-type/:issue_type_id',
                    name: 'issue-type-edit',
                    component: () => import('./views/DropDown/IssueType/IssueTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // accident-classification 
                {
                    path: '/dropdown/accident-classifications',
                    name: 'accident-classification-list',
                    component: () => import('./views/DropDown/AccidentClassification/AccidentClassificationList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/accident-classification/new',
                    name: 'accident-classification-new',
                    component: () => import('./views/DropDown/AccidentClassification/AccidentClassificationEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/accident-classification/:accident_classification_id',
                    name: 'accident-classification-edit',
                    component: () => import('./views/DropDown/AccidentClassification/AccidentClassificationEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // vehicle type
                {
                    path: '/dropdown/vehicle-types',
                    name: 'vehicle-type-list',
                    component: () => import('./views/DropDown/VehicleType/VehicleTypeList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/vehicle-type/new',
                    name: 'vehicle-type-new',
                    component: () => import('./views/DropDown/VehicleType/VehicleTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/vehicle-type/:vehicle_type_id',
                    name: 'vehicle-type-edit',
                    component: () => import('./views/DropDown/VehicleType/VehicleTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // cause 
                {
                    path: '/dropdown/causes',
                    name: 'cause-list',
                    component: () => import('./views/DropDown/Cause/CauseList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/cause/new',
                    name: 'cause-new',
                    component: () => import('./views/DropDown/Cause/CauseEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/cause/:cause_id',
                    name: 'cause-edit',
                    component: () => import('./views/DropDown/Cause/CauseEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // authority-type
                {
                    path: '/dropdown/authority-types',
                    name: 'authority-type-list',
                    component: () => import('./views/DropDown/AuthorityType/AuthorityTypeList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/authority-type/new',
                    name: 'authority-type-new',
                    component: () => import('./views/DropDown/AuthorityType/AuthorityTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/authority-type/:authority_type_id',
                    name: 'authority-type-edit',
                    component: () => import('./views/DropDown/AuthorityType/AuthorityTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // nature-of-accident
                {
                    path: '/dropdown/nature-of-accidents',
                    name: 'nature-of-accident-list',
                    component: () => import('./views/DropDown/NatureOfAccident/NatureOfAccidentList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/nature-of-accident/new',
                    name: 'nature-of-accident-new',
                    component: () => import('./views/DropDown/NatureOfAccident/NatureOfAccidentEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/nature-of-accident/:nature_of_accident_id',
                    name: 'nature-of-accident-edit',
                    component: () => import('./views/DropDown/NatureOfAccident/NatureOfAccidentEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                 // road-feature
                 {
                    path: '/dropdown/road-features',
                    name: 'road-feature-list',
                    component: () => import('./views/DropDown/RoadFeature/RoadFeatureList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/road-feature/new',
                    name: 'road-feature-new',
                    component: () => import('./views/DropDown/RoadFeature/RoadFeatureEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/road-feature/:road_feature_id',
                    name: 'road-feature-edit',
                    component: () => import('./views/DropDown/RoadFeature/RoadFeatureEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // road-condition
                {
                    path: '/dropdown/road-conditions',
                    name: 'road-condition-list',
                    component: () => import('./views/DropDown/RoadCondition/RoadConditionList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/road-condition/new',
                    name: 'road-condition-new',
                    component: () => import('./views/DropDown/RoadCondition/RoadConditionEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/road-condition/:road_condition_id',
                    name: 'road-condition-edit',
                    component: () => import('./views/DropDown/RoadCondition/RoadConditionEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // intersection-type
                {
                    path: '/dropdown/intersection-types',
                    name: 'intersection-type-list',
                    component: () => import('./views/DropDown/IntersectionType/IntersectionTypeList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/intersection-type/new',
                    name: 'intersection-type-new',
                    component: () => import('./views/DropDown/IntersectionType/IntersectionTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/intersection-type/:intersection_type_id',
                    name: 'intersection-type-edit',
                    component: () => import('./views/DropDown/IntersectionType/IntersectionTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // weather-condition
                {
                    path: '/dropdown/weather-conditions',
                    name: 'weather-condition-list',
                    component: () => import('./views/DropDown/WeatherCondition/WeatherConditionList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/weather-condition/new',
                    name: 'weather-condition-new',
                    component: () => import('./views/DropDown/WeatherCondition/WeatherConditionEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/weather-condition/:weather_condition_id',
                    name: 'weather-condition-edit',
                    component: () => import('./views/DropDown/WeatherCondition/WeatherConditionEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },

                // enroachment-type
                {
                    path: '/dropdown/enroachment-types',
                    name: 'enroachment-type-list',
                    component: () => import('./views/DropDown/EnroachmentType/EnroachmentTypeList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/enroachment-type/new',
                    name: 'enroachment-type-new',
                    component: () => import('./views/DropDown/EnroachmentType/EnroachmentTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/enroachment-type/:enroachment_type_id',
                    name: 'enroachment-type-edit',
                    component: () => import('./views/DropDown/EnroachmentType/EnroachmentTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },

                // help-type
                {
                    path: '/dropdown/help-types',
                    name: 'help-type-list',
                    component: () => import('./views/DropDown/HelpType/HelpTypeList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/help-type/new',
                    name: 'help-type-new',
                    component: () => import('./views/DropDown/HelpType/HelpTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/help-type/:help_type_id',
                    name: 'help-type-edit',
                    component: () => import('./views/DropDown/HelpType/HelpTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // accident-type
                {
                    path: '/dropdown/accident-types',
                    name: 'accident-type-list',
                    component: () => import('./views/DropDown/AccidentType/AccidentTypeList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/accident-type/new',
                    name: 'accident-type-new',
                    component: () => import('./views/DropDown/AccidentType/AccidentTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/accident-type/:accident_type_id',
                    name: 'accident-type-edit',
                    component: () => import('./views/DropDown/AccidentType/AccidentTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // type-of-program
                {
                    path: '/dropdown/type-of-programs',
                    name: 'type-of-program-list',
                    component: () => import('./views/DropDown/TypeOfProgram/TypeOfProgramList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/type-of-program/new',
                    name: 'type-of-program-new',
                    component: () => import('./views/DropDown/TypeOfProgram/TypeOfProgramEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/type-of-program/:type_of_program_id',
                    name: 'type-of-program-edit',
                    component: () => import('./views/DropDown/TypeOfProgram/TypeOfProgramEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // hazard type 
                {
                    path: '/dropdown/hazard-types',
                    name: 'hazard-type-list',
                    component: () => import('./views/DropDown/HazardType/HazardTypeList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/hazard-type/new',
                    name: 'hazard-type-new',
                    component: () => import('./views/DropDown/HazardType/HazardTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/hazard-type/:hazard_type_id',
                    name: 'hazard-type-edit',
                    component: () => import('./views/DropDown/HazardType/HazardTypeEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // type of road
                {
                    path: '/dropdown/type-of-roads',
                    name: 'type-of-road-list',
                    component: () => import('./views/DropDown/TypeOfRoad/TypeOfRoadList.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/type-of-road/new',
                    name: 'type-of-road-new',
                    component: () => import('./views/DropDown/TypeOfRoad/TypeOfRoadEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/dropdown/type-of-road/:type_of_road_id',
                    name: 'type-of-road-edit',
                    component: () => import('./views/DropDown/TypeOfRoad/TypeOfRoadEdit.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                // User Role Permission
                {
                    path: '/role-permission/create',
                    name: 'create-role-permission',
                    component: () => import('./views/permissions/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/role-permission/:role_permission_id',
                    name: 'edit-role-permission',
                    component: () => import('./views/permissions/Edit.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                },
                {
                    path: '/list-role-permissions',
                    name: 'list-role-permissions',
                    component: () => import('./views/permissions/List.vue'),
                    meta: {
                        rule: 'subscriber',
                    }
                }
            ],
        },
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: '/accounts/login',
                    name: 'page-login',
                    // redirect: api.base_auth_url + api.native_auth_urls.login,
                    component: () => import('@/views/pages/Login.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/accounts/register',
                    name: 'page-register',
                    component: () => import('@/views/pages/Register.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/accounts/logout',
                    name: 'page-logout',
                    component: () => import('@/views/pages/Logout.vue'),
                    meta: {
                        rule: 'subscriber',
                        skip_organisation: true
                    }
                },
                {
                    path: '/accounts/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                // {
                //     path: '/pages/comingsoon',
                //     name: 'page-coming-soon',
                //     component: () => import('@/views/pages/ComingSoon.vue'),
                //     meta: {
                //         rule: 'public'
                //     }
                // },
                {
                    path: '/errors/404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/errors/500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/errors/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
                {
                    path: '/errors/offline',
                    name: 'page-offline',
                    component: () => import('@/views/pages/Offline.vue'),
                    meta: {
                        rule: 'public',
                        skip_organisation: true
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            name: 'page-error-404',
            component: () => import('@/views/pages/Error404.vue'),
            meta: {
                rule: 'public'
            }
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
    if(store.state.active_service_worker){
        store.state.active_service_worker.update()
    }
})

router.beforeEach((to, from, next) => {
    // console.log("Accessing ", to.path, " and You're online? ", navigator.onLine)

    const next_url = to.fullPath

    // if(!navigator.onLine) {
    //     if(to.path != '/errors/offline'){
    //         // console.log("Redirected to offline")
    //         return next({name: 'page-offline', params: {next: to.path}})
    //     }
    //     else
    //         return next()
    // }
    
    
    if(to.meta.rule == 'admin' || to.meta.rule == 'subscriber'){
        auth.isAuthenticated().then( (res) => {
            next()
        }, (err) => {
            if (to.name === 'forgot-password') {
                next()
            } else{
                console.log('Redirecting')
                return next({name: 'page-login', query: {next: next_url}})
            }
        })
    }
    else {
        next()
    }

});

export default router
